export default __webpack_public_path__ + "static/media/AE1.ba2c79e4.jpg";